import { makeObservable, observable, action } from "mobx";

interface Modal {
  modalType: string;
  props: any;
}

class ModalStore {
  activeModals: Modal[] = [];
  modalProps = {};

  constructor() {
    makeObservable(this, {
      activeModals: observable,
      modalProps: observable,
      openModal: action,
      closeModal: action,
    });
  }

  openModal = (modalType: string, props: any) => {
    this.activeModals.push({ modalType, props });
  };

  closeModal = (modalType: string) => {
    this.activeModals = this.activeModals.filter(modal => modal.modalType !== modalType);
  };
}

const modalStore = new ModalStore();
export default modalStore;
